<div class="container-fluid">
    <div class="row">
        <div class="col-md-12 five mt-2">
            <!--<h1>product inclusion</h1>-->
        </div>
    </div>
    <form (ngSubmit)="onSubmit()" [formGroup]="productInclusionDetails" id="productInclusionDetails">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <select class="form-select" formControlName="shopId" (change)="getShopName($event)">
                        <option value="" disabled selected>Select Shop Name</option>
                        <option *ngFor="let shop of shopList" value="{{shop.traderId}}">{{ shop.traderName }}</option>
                    </select>
                    <label>Shop Name<span class="text-danger">*</span></label>
                    <span *ngIf="productInclusionErrors.shopName"
                          class="error-text">{{ productInclusionErrors.shopName }}</span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <select class="form-select" id="category" formControlName="mainProductCategory"
                            (change)="selectCategory($event)">
                        <option value="" disabled selected>Select Product Category</option>
                        <option *ngFor="let category of mainCategoryList"
                                [value]="category.catId">{{ category.catName }}
                        </option>
                        <option value="Others" *ngIf="!this.productId">Others</option>
                    </select>
                    <label>Product Category<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.mainProductCategory"
                          class="error-text">{{ productInclusionErrors.mainProductCategory }}</span>
                </div>
            </div>

            <div *ngIf="newMainCategoryAdd" class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input class="form-control" formControlName="newMainCategory"
                           placeholder="Enter Main Category Name" (input)="checkCategoryExistList($event)">
                    <label>Main Category Name<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.newMainCategory"
                          class="error-text">{{ productInclusionErrors.newMainCategory }}</span>
                    <span *ngIf="productInclusionDetails.get('newMainCategory')?.hasError('categoryExists') && productInclusionDetails.get('newMainCategory')?.touched"
                          class="error-text"> Main Category Name already exists</span>
                </div>
            </div>

            <div *ngIf="newMainCategoryAdd" class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input class="form-control" formControlName="newSubCategory" placeholder="Enter Sub Category Name">
                    <label>Sub Category Name<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.newSubCategory"
                          class="error-text">{{ productInclusionErrors.newSubCategory }}</span>
                </div>
            </div>

            <div *ngIf="!newMainCategoryAdd" class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <select class="form-select" id="subcategory" formControlName="subProductCategory"
                            (change)="selectSubCategory($event)">
                        <option value="" disabled selected>Select Product Sub Category</option>
                        <option *ngFor="let sub of subCategory" [value]="sub.subCatId">{{ sub.subCatName }}</option>
                        <option value="Others" *ngIf="!this.productId">Others</option>
                    </select>
                    <label>Sub Category<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.subCategory"
                          class="error-text">{{ productInclusionErrors.subCategory }}</span>
                </div>
            </div>

            <div *ngIf="newSubCategoryAdd" class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input class="form-control" formControlName="newSubCategory" placeholder="Enter Sub Category Name"
                           (input)="checkSubCategoryExistList($event)">
                    <label>Sub Category Name<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.newSubCategory"
                          class="error-text">{{ productInclusionErrors.newSubCategory }}</span>
                    <span *ngIf="productInclusionDetails.get('newSubCategory')?.hasError('subCategoryExists') && productInclusionDetails.get('newSubCategory')?.touched"
                          class="error-text"> Sub Category Name already exists</span>
                </div>
            </div>


            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="brandName" formControlName="brandName"
                           placeholder="Enter Brand Name">
                    <label>Brand Name<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.brandName"
                          class="error-text">{{ productInclusionErrors.brandName }}</span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="productName" formControlName="productName"
                           placeholder="Enter Product Name">
                    <label>Product Name<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.productName"
                          class="error-text">{{ productInclusionErrors.productName }}</span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="quantityValue" formControlName="quantityValue"
                           placeholder="Enter Quantity Value" (keypress)="OnlyNumbers($event)">
                    <label>Quantity (e.g., 100 for 100ml)<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.quantityValue"
                          class="error-text">{{ productInclusionErrors.quantityValue }}</span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12 mb-3">
                <div class="form-floating">
                    <select class="form-select"
                            id="quantityType"
                            formControlName="quantityType">
                        <option value="" disabled selected>Select UOM</option>
                        <option *ngFor="let uom of quantityTypes" [value]="uom">{{ uom }}</option>
                    </select>
                    <label for="quantityType">Quantity Type (UOM) <span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.quantityType" class="error-text">
      {{ productInclusionErrors.quantityType }}
    </span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="price" formControlName="shopProductMRP"
                           placeholder="Enter Product MRP" (keypress)="OnlyNumbers($event)" maxlength="7">
                    <label>Product MRP<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.shopProductMRP"
                          class="error-text">{{ productInclusionErrors.shopProductMRP }}</span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="SRP" formControlName="shopProductSRP"
                           placeholder="Enter Product Sale Price" (keypress)="OnlyNumbers($event)" maxlength="7">
                    <label>Product Sale Price<span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.shopProductSRP"
                          class="error-text">{{ productInclusionErrors.shopProductSRP }}</span>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="number" class="form-control" id="gst" formControlName="gst"
                           (input)="gstCalculation($event)"
                           placeholder="Enter Product GST in (%)" min="0" max="18" maxlength="2">
                    <label>GST(%)<span style="color:red;">*</span></label>
                    <div *ngIf="productInclusionDetails.get('gst')?.touched && productInclusionDetails.get('gst')?.invalid"
                         class="error-text">
                        <ng-container *ngIf="productInclusionDetails.get('gst')?.errors?.['required']">*GST is
                            required
                        </ng-container>
                        <ng-container *ngIf="productInclusionDetails.get('gst')?.errors?.['invalidNumber']">*GST must be
                            a number
                        </ng-container>
                        <ng-container *ngIf="productInclusionDetails.get('gst')?.errors?.['gstOutOfRange']">*GST must be
                            between 0 to
                            18
                        </ng-container>
                        <!--<ng-container *ngIf="productInclusionDetails.get('gst')?.errors?.['gstZero']">
                            *GST must be greater than 0
                        </ng-container>-->
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="cGst" formControlName="cgst"
                           placeholder="Enter Product CGST in (%)" readonly>
                    <label>CGST(%)</label>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="text" class="form-control" id="sGst" formControlName="sgst"
                           placeholder="Enter Product SGST in (%)" readonly>
                    <label>SGST(%)</label>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-12 mb-3">
                <div class="form-floating">
                    <textarea class="form-control" id="productShortDescription"
                              formControlName="productShortDescription"
                              placeholder="Enter Product Short Description" style="height: 100px"></textarea>
                    <label for="productShortDescription">Short Description <span style="color:red;">*</span></label>
                    <span *ngIf="productInclusionErrors.productShortDescription"
                          class="error-text">{{ productInclusionErrors.productShortDescription }}</span>
                </div>

                <small class="text-muted">
                    Word count: {{ getWordCount('productShortDescription') }}/20
                </small>
            </div>


            <div class="col-lg-3 col-md-6 col-12  mb-3">
                <div class="form-floating">
                    <input type="file" class="form-control" id="fileUpload"
                           (change)="onFileSelected($event)">
                    <label for="fileUpload" class="form-label">Upload Image</label>
                </div>
                <span class="text-danger" style="font-size: 14px">
                                        <b>Image Requirements:</b>
                                        <b class="ml-3">File Size:</b> Below 2 MB,
                                        <b class="ml-3">File Formats:</b> JPG, PNG
                                    </span>
            </div>

            <div class="col-lg-3 col-md-6 col-12 mb-3" *ngIf="imagePreviews.length > 0">
                <div *ngFor="let preview of imagePreviews">
                    <img [src]="preview" alt="Image Preview" style="width: 150px; margin: 10px;"/>
                </div>

            </div>
            <div class="col-lg-3 col-md-6 col-12 mb-3" *ngIf="shopProductDetails != null && imagePreviews.length == 0">
                <img [src]="getImage()" alt="Image Preview" style="width: 150px; margin: 10px;"/>
            </div>


            <div class="col-lg-12 col-md-12 col-12  mb-3">
                <label>Description<span style="color:red;">*</span></label>
                <div class="form-floating">
                    <quill-editor
                            formControlName="shopProductDescription"
                            (onEditorCreated)="onEditorCreated($event)"
                            [style]="{ height: '250px' }"
                            [modules]="editorModules"
                            [placeholder]="'Write your content here...'">
                    </quill-editor>
                </div>
                <span *ngIf="productInclusionErrors.shopProductDescription"
                      class="error-text">{{ productInclusionErrors.shopProductDescription }}</span>
            </div>
        </div>

        <div class="row text-center">
            <div class="col-md-12">
                <div class="text-center mb-5">
                    <button type="submit" class="btnColor" *ngIf="!productId">Click to Include</button>
                    <button type="submit" class="btnColor" *ngIf="productId">Update</button>
                </div>
            </div>
            <div class="row text-center mb-5"></div>
        </div>
    </form>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium">
    <div class="loader">
        <div class="inner one"></div>
        <div class="inner two"></div>
        <div class="inner three"></div>
    </div>
</ngx-spinner>
